import { BaseChatPackage } from '../utils'
import { useCallback, useEffect } from 'react'
import type { ChatChannelInstance } from '../types'

export type SyncChannelMembersOptions = { enabled?: boolean }
export class UseSyncChannelMembers extends BaseChatPackage {
  useSyncChannelMembers(
    channel: ChatChannelInstance | null,
    options?: SyncChannelMembersOptions
  ) {
    const { enabled = true } = options || {}

    const handleMemberChange = useCallback(async (event: any) => {
      const eventChannelId = event.channel_id ||
        (event.cid ? event.cid.split(':')[1] : null) ||
        (event.channel?.id)

      if (eventChannelId && eventChannelId !== channel?.id) return

      const eventType = event?.type

      const addEvents = ['member.added', 'notification.added_to_channel']
      const deleteEvents = ['member.removed', 'notification.removed_from_channel']
      const updateEvents = ['member.updated', 'user.updated']

      const member = event?.member

      if (!member) return

      if (addEvents.includes(eventType)) {
        const count = this.queries?.members.manager.getItemCount({ channelId: channel?.id as string }) || 0

        if (count === this.queries?.members.LIMIT) {
          return this.queries.members.invalidateMembers()
        }

        if (count > this.queries?.members.LIMIT) {
          return
        }

        const existingMember = await this.queries?.members.manager.getItem(member?.user_id)

        if (!existingMember) {
          this.queries?.members.manager.addItem({ item: { ...member, id: member?.user_id }, to: 'end' })
        }
      }

      if (deleteEvents.includes(eventType)) {
        this.queries?.members.manager.removeItem(member?.user_id)
      }

      if (updateEvents.includes(eventType)) {
        const isModerator = member?.is_moderator
        this.queries?.members.manager.updateItem(member?.user_id, { ...member, is_moderator: isModerator })
      }
    }, [channel])

    useEffect(() => {
      if (!channel || !enabled) return

      const channelSubs = [
        channel.on('member.added', handleMemberChange),
        channel.on('member.removed', handleMemberChange),
        channel.on('member.updated', handleMemberChange),
      ]

      const client = (channel as any).getClient?.() || (channel as any).client
      let clientSubs: any[] = []

      if (client) {
        clientSubs = [
          client.on('notification.added_to_channel', handleMemberChange),
          client.on('notification.removed_from_channel', handleMemberChange),
          client.on('user.updated', handleMemberChange),
        ]
      }

      return () => {
        channelSubs.forEach(s => s?.unsubscribe?.())
        clientSubs.forEach(s => s?.unsubscribe?.())
      }
    }, [channel, enabled, channel?.id])
  }
}


